import React from 'react';
import { UserRole } from '../types/videocall.types';
import CircularLoader from './CircularLoader';
import EmptyMessage from './EmptyMessage';

interface VideoCallStatusProps {
  status: 'loading' | 'error' | 'redirecting';
  errorMessage?: string | null;
  userRole?: UserRole;
  baseUrl?: string;
}

const VideoCallStatus: React.FC<VideoCallStatusProps> = ({
  status,
  errorMessage,
  userRole,
  baseUrl = 'https://www.iknowly.com',
}) => {
  const fallbackPath = `${baseUrl}${
    userRole === 'CONSULTANT'
      ? '/consultant/dashboard/sessions'
      : '/consultee/dashboard/sessions'
  }`;

  if (status === 'loading') {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <CircularLoader />
        <p className="text-lg font-medium text-gray-700 text-center">Joining iKnowly Room...</p>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex items-center justify-center h-screen">
        <EmptyMessage
          message={errorMessage || 'Failed to load meeting details. Please try again.'}
          size="lg"
          fallbackLinkUrl={fallbackPath}
          fallbackLinkText="Go back to Dashboard"
          showTimer
          autoRedirect
          timerDuration={5}
        />
      </div>
    );
  }

  if (status === 'redirecting') {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <CircularLoader />
        <p className="text-lg font-medium text-gray-700 text-center">
          Thank you for choosing iKnowly
          <br />

          Redirecting to your dashboard..

        </p>
      </div>
    );
  }

  return null;
};

export default VideoCallStatus;
